module.exports = __webpack_public_path__ + "img/talhadeira enc quadrado ponta curva - mobile.57855ada.png";